export default function sortPhotos(items, direction) {
  const date = item => (Number(item.year) || 0) * 10000 + (Number(item.month) || 0) * 100 + (Number(item.day) || 0);
  return [...items].sort((a, b) => (date(a) - date(b)) * (direction === 'oldest' ? 1 : -1));
}
